import httpManager from "@/app/shared/utils/httpManager";

export async function fetchStatus() {
  const url = `/monitoring/states/`;
  const response = await httpManager.get(url);
  return response.data;
}
